// extracted by mini-css-extract-plugin
export default {"carouselWrapper":"styles_carouselWrapper__JjSGc","carousel":"styles_carousel__HCvzK","is-active":"styles_is-active__jDpkj","spin":"styles_spin__41-au"};